import { useMemo } from 'react';
import { consoleLogger } from '../config/di/container';

export const useApplicationLogger = () => {
  return useMemo(() => consoleLogger, []);
};
